<mat-card>{{'messages' | translate}}</mat-card>


<div class="container" style="padding: 25px;">


  <!-- <button mat-icon-button cdkCopyToClipboard="4444">
    <mat-icon>file_copy</mat-icon>
  </button> -->

  <mat-grid-list cols="4" rowHeight="50px">
    <mat-grid-tile cols="2">
      <mat-form-field appearance="standard">
        <mat-label>{{'filter' | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile cols="2">
      <button mat-raised-button color="primary" style="background-color: red;" (click)="onDeleteAll()">
        <mat-icon>delete</mat-icon>
        {{'deleteAll' | translate}}
      </button>
    </mat-grid-tile>

  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.date | date: 'dd/MM/yyyy hh:mm a'}} </td>
      </ng-container>

      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'fullName' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
      </ng-container>

      <ng-container matColumnDef="mobileNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'mobileNo' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.userName}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container ntainer matColumnDef="messageText">
        <th mat-header-cell *matHeaderCellDef mat-sort-header align="center">
          {{'messageText' | translate}}

        </th>
        <td mat-cell *matCellDef="let row" [innerHTML]="row.message" align="center">
        </td>
      </ng-container>

      <ng-container matColumnDef="copy">
        <th mat-header-cell *matHeaderCellDef> {{'copyPlayerId' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button *ngIf="row.playerId != null && row.playerId != ''"
            (click)="copyPlayerId(row.playerId)">
            <mat-icon>file_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="imageUrl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'image' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <img src="{{row.imageUrl}}" alt="no image" width="80" style="cursor: pointer;"
            (click)="viewImg(row.imageUrl)">
        </td>
      </ng-container>

      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef> {{'view' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="edit(row)">
            <mat-icon>pageview</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="updateStatus" *ngIf="selectedMessageType != 2 
      && selectedStatus != 1 && selectedStatus !=2">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'chargedDone' | translate}} </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
          <button mat-raised-button color="primary" *ngIf="row.status == 0" (click)="onChargedDone(row)">
            <mat-icon>save</mat-icon>
            {{'chargedDone' | translate}}
          </button>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="reject" *ngIf="selectedMessageType != 2
      && selectedStatus != 1 && selectedStatus !=2">
        <th mat-header-cell *matHeaderCellDef> {{'reject' | translate}} </th>
        <td mat-cell *matCellDef="let row;let i = index;" style="padding: 10px;">
          <button mat-raised-button color="primary" (click)="onReject(row)" *ngIf="row.status == 0">
            <mat-icon>call_missed</mat-icon>
            {{'reject' | translate}}
          </button>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="onDelete(row.id)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToDelete' | translate}}</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
  </div>

</ng-template>

<ng-template #ModalView>

  <div align="center">
    <h1 mat-dialog-title>{{'messageText' | translate}}</h1>
    <div mat-dialog-content [innerHTML]="message_text" dir="rtl"></div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
  </div>

</ng-template>

<ng-template #ModalViewImg>

  <!-- <h1 mat-dialog-title>{{'messageText' | translate}}</h1> -->
  <div mat-dialog-content>
    <img src="{{imgView}}" alt="no image" width="100%" height="100%">
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
  </div>

</ng-template>


<ng-template #ModalConfirmReject>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToReject' | translate}}</p>
    <mat-form-field appearance="standard">
      <mat-label>{{'rejectReason' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="rejectReason"></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="confirmReject()">{{'yes' | translate}}</button>
  </div>

</ng-template>


<ng-template #ModalDeleteAll>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p> هل انت متأكد من حذف الجميع ؟</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmDeleteBulk()">تأكيد الحذف</button>
  </div>

</ng-template>